export default __webpack_public_path__ + "static/media/clear4.529df8a4.mp3";